import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconProjectChanged = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" sx={{ fill: 'none', ...props.sx }}>
    <path
      d="M19 12V8.7241C19 8.25623 18.836 7.80316 18.5364 7.44373L14.5997 2.71963C14.2197 2.26365 13.6568 2 13.0633 2H11H7C4.79086 2 3 3.79086 3 6V18C3 20.2091 4.79086 22 7 22H12"
      stroke="#FFAB00"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14 2.5V6C14 7.10457 14.8954 8 16 8H18.5"
      stroke="#FFAB00"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M14.4492 17.6282C14.4492 17.6282 15.2461 16.5425 15.8934 15.8947C16.5408 15.2469 17.4354 14.8461 18.4236 14.8461C20.3991 14.8461 22.0005 16.4476 22.0005 18.4231C22.0005 20.3985 20.3991 22 18.4236 22C17.1834 22 16.0907 21.3688 15.449 20.4102M14.4492 17.6282V15.2436M14.4492 17.6282H16.8338"
      stroke="#FFAB00"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
)
